var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressBarTruckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#E7F5E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3936 14.2687L29.3936 18.3037C29.5753 18.7358 29.6934 19.4362 29.6934 19.7694C29.6934 20.1027 29.6934 21.7914 29.6934 21.7914C29.6934 22.34 29.2442 22.7905 28.6937 22.7905H27.4971C27.3767 24.0303 26.3319 24.9987 25.0601 24.9987C23.7884 24.9987 22.7428 24.0303 22.6224 22.7906H21.1564V13.1767L25.9585 13.1763C26.5081 13.1763 27.1314 13.786 27.3936 14.2687ZM25.0601 23.7743C25.7362 23.7743 26.2851 23.2257 26.2851 22.5499C26.2851 21.8742 25.7362 21.3271 25.0601 21.3271C24.3832 21.3271 23.8351 21.8741 23.8351 22.5499C23.8351 23.2258 24.3833 23.7743 25.0601 23.7743ZM22.4433 14.4994V17.5H27.3936L26.2851 15.0827C26.1847 14.8973 25.635 14.4994 25.4249 14.4994H22.4433Z",
    fill: "#0E9926"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11V22.7918H13.2667C13.1506 24.0315 12.129 25 10.8863 25C9.64294 25 8.62278 24.0315 8.5037 22.7918H6V11H20ZM10.8863 23.7756C11.5469 23.7756 12.0833 23.227 12.0833 22.5512C12.0833 21.8754 11.5469 21.3283 10.8863 21.3283C10.2249 21.3283 9.68934 21.8754 9.68934 22.5512C9.68934 23.227 10.225 23.7756 10.8863 23.7756Z",
    fill: "#0E9926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressBarTruckIcon);
export default __webpack_public_path__ + "static/media/progressBarTruckIcon.5b09832e4b964841277116bedd21871c.svg";
export { ForwardRef as ReactComponent };